import React from 'react';
import '../../App.css';

export default function Venue() {
  return <h1 className='venue'>VENUE</h1>;
}